import React from 'react'
import './resources/MenuButton.css'
import { MenuButtonProps } from './types/MenuButtonProps'

export const MenuButton: React.FunctionComponent<MenuButtonProps> = ({ title, link }: MenuButtonProps) => (
  <a className='menu-button' href={link}>
    {title}
  </a>
)
